import { RouteLocationRaw } from "vue-router";
import { UserRole } from "@/core/services/api/enums/UserRole";
import store from "@/store";
import { GuardedElement } from "@/core/config/MainMenuConfig";

export interface ActionElement extends GuardedElement<ActionElement> {
  heading: () => string;
  route: RouteLocationRaw;
  svgIcon?: string;
  fontIcon?: string;
}

export const ActionBarElements: ActionElement[] = [
  {
    heading: (): string => "Dashboard",
    route: { name: "admin.dashboard" },
    svgIcon: "/media/icons/duotune/general/gen001.svg",
    roles: [UserRole.SUPER_ADMIN, UserRole.ADMIN],
  },
  {
    heading: (): string => "Dashboard",
    route: { name: "manager.dashboard" },
    svgIcon: "/media/icons/duotune/general/gen001.svg",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled && store.getters.isIndividualOrHas2FA,
  },
  {
    heading: (): string => "Deposit crypto",
    route: {
      name: "manager.crypto.deposit",
    },
    svgIcon: "/media/icons/duotune/finance/fin005.svg",
    roles: [UserRole.MANAGER],
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled &&
      store.getters.userHasTwoFactorAuth &&
      store.getters.isCompanyCryptoEnabled,
  },
  {
    heading: (): string => "Sell crypto",
    route: {
      name: "manager.crypto.sell",
    },
    svgIcon: "/media/icons/duotune/finance/cash-payment.svg",
    roles: [UserRole.MANAGER],
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled &&
      store.getters.userHasTwoFactorAuth &&
      store.getters.isCompanyCryptoEnabled,
  },
  {
    heading: (): string => "Buy crypto",
    route: {
      name: "manager.crypto.buy",
    },
    svgIcon: "/media/icons/duotune/finance/bitcoin.svg",
    roles: [UserRole.MANAGER],
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled &&
      store.getters.userHasTwoFactorAuth &&
      store.getters.isCompanyCryptoEnabled,
  },
  {
    heading: (): string => "Withdraw crypto",
    route: {
      name: "manager.crypto.withdraw",
    },
    svgIcon: "/media/icons/duotune/finance/withdraw.svg",
    roles: [UserRole.MANAGER],
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled &&
      store.getters.userHasTwoFactorAuth &&
      store.getters.isCompanyCryptoEnabled,
  },
  {
    heading: (): string => "Open ticket",
    route: {
      name: "manager.support.tickets.list",
    },
    svgIcon: "/media/icons/duotune/graphs/gra006.svg",
    roles: [UserRole.MANAGER, UserRole.MANAGER_READER],
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled &&
      store.getters.isIndividualOrHas2FA &&
      store.getters.isCompanyCryptoEnabled,
  },
  {
    heading: (): string => "Withdraw",
    route: {
      name: "manager.transactions.create",
      params: {
        action: "create",
        method: "iban",
      },
    },
    svgIcon: "/media/icons/duotune/finance/fin001.svg",
    roles: [UserRole.MANAGER],
    isAllowed: (): boolean =>
      store.getters.isUserCompanyEnabled &&
      store.getters.userHasTwoFactorAuth &&
      store.getters.isCompanyCryptoEnabled,
  },
];
